if (!customElements.get('fls-quantity-packs')) {
  customElements.define('fls-quantity-packs', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.quantity = this.productInfo?.querySelector('.quantity__input');
      if (!this.quantity) {
        this.hidden = true;
        return;
      }
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-pack-quantity]')) return;
        this.quantity.value = event.target.value;
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }, options);
      this.quantity.addEventListener('change', () => this.sync(), options);
      this.quantity.addEventListener('input', () => this.sync(), options);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.quantity, { attributes: true, attributeFilter: ['min', 'max', 'step', 'value'] });
      this.sync();
    }

    sync() {
      const min = Number(this.quantity.min) || 1;
      const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
      const step = Number(this.quantity.step) || 1;
      this.querySelectorAll('[data-pack-quantity]').forEach((radio) => {
        const count = Number(radio.value);
        radio.disabled = radio.dataset.available !== 'true' || count < min || count > max || (count - min) % step !== 0;
        radio.checked = !radio.disabled && count === Number(this.quantity.value);
      });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
